import { TElement } from '@udecode/plate-common'
import { Transformer } from 'unified'

export const ELEMENT_EDITED = 'edited'

const edited = (withSpace = false) =>
    ({
        type: ELEMENT_EDITED,
        children: [
            {
                type: 'text',
                value: `${withSpace ? ' ' : ''}(edited)`,
                text: `${withSpace ? ' ' : ''}(edited)`,
            },
        ],
    }) as TElement

/**
 * This function adds an annotation at the end of the message if the message is edited.
 * * If last node is a paragraph, we add a special element EDITED as a child of the paragraph.
 * * If last node is not a paragraph, we add a new paragraph with the special element EDITED.
 */
const remarkEditedAnnotation = (isEdited: boolean) => () => {
    const transformer: Transformer = (tree, _file) => {
        if (!isEdited) {
            return
        }

        const rootChildren = (tree as unknown as TElement).children
        const lastRootNode = rootChildren.length > 0 ? rootChildren[rootChildren.length - 1] : null

        if (lastRootNode && lastRootNode.type === 'paragraph') {
            ;(lastRootNode as TElement).children.push(edited(true))
        } else {
            rootChildren.push({
                type: 'paragraph',
                children: [edited()],
            })
        }
    }

    return transformer
}

export default remarkEditedAnnotation
